import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { VolunteerLoginPage } from './pages/VolunteerLoginPage';
import { ValidateTokenPage } from './pages/ValidateTokenPage';
import { VolunteerSignup } from './pages/VolunteerSignup';
import { Dashboard } from './pages/Dashboard';
import { VolunteerDashboard } from './pages/VolunteerDashboard';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminUserDetail } from './pages/AdminUserDetail';
import { AdminUserLookup } from './pages/AdminUserLookup';
import { SupervisorDashboard } from './pages/SupervisorDashboard';
import { SickNote } from './pages/SickNote';
import './styles/globals.css';

export function App() {
  return (
    <Router>
      <Routes>
        <Route path="/volunteer-login" element={<VolunteerLoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/login/:token" element={<ValidateTokenPage />} />
        <Route path="/signup" element={<VolunteerSignup />} />
        <Route path="/" element={<VolunteerDashboard />} />
        <Route path="/shifts" element={<Dashboard />} />
        <Route path="/sick-note" element={<SickNote />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/users/:id" element={<AdminUserDetail />} />
        <Route path="/admin/users/by-email" element={<AdminUserLookup />} />
        <Route path="/supervisor" element={<SupervisorDashboard />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
